import pt from '../../locales/pt';
import { cn } from '../../utils/cn';
import { allocationDotClass } from '../../utils/quickCreateAllocation';
import { goalAllocationShortLabel } from '../../utils/goalDisplayUtils';

/** ds/card/goal-vision-hero + ds/tile/goal-vision no .pen — pill sobre imagem. */
export function GoalAllocationTag({ allocation, className }) {
  if (!allocation) return null;
  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center gap-space-1 rounded-ds-full bg-on-hero-track px-space-2 py-space-1 type-chip text-on-hero',
        className,
      )}
    >
      <span className={cn('h-2 w-2 rounded-full', allocationDotClass(allocation))} aria-hidden />
      {goalAllocationShortLabel(allocation, pt)}
    </span>
  );
}
